import { useImperativeHandle, useRef } from 'react';
import { Button, ControlLabel, Dialog, DialogContent, DialogRef, Stack } from 'src/app/components';
import { HookFormProvider, InputSelect } from 'src/app/components/HookForm';
import { useTabDraw } from '../LuckyDrawDetailTabDraw.hook';
import { DrawingModel } from 'src/app/modules/campaign/models/LuckyDraw.model';
interface TabDrawSetAsWinnerProps {
  dialogRef: React.RefObject<DialogRef>;
  submit: () => void;
}

const TabDrawSetAsWinnerPopup = ({ dialogRef, submit }: TabDrawSetAsWinnerProps) => {
  const state = useTabDraw();
  const submitButtonClick = state.form.handleSubmit(async ({ ...formData }) => {
    const payload = {
      prize_id: isConsolation? formData.prize?.id:undefined,
      member_coupon_id: formData.id
    }
    hitPostAPI(payload);
  })

  const hitPostAPI = async (payload: {prize_id?: string, member_coupon_id?: string}) => {
    try {
      await state.submit.mutateAsync(payload)
      submit && submit()
      clickCancel()
    } catch (error: any) {
      console.error(error)
    }
  }

  const localRef = useRef<DialogRef>(null);

  function clickCancel() {
    state.form.reset();
    localRef.current?.hide();
  }

  const isConsolation = state.form.watch('prize_type') === 'CONSOLATION'
  const prize = state.form.watch('prize')
  const member = state.form.watch('member')

  useImperativeHandle(dialogRef, () => ({
    show: (data) => localRef.current?.show(() => {
      const entries = Object.entries(data as object) as [keyof DrawingModel, any][];
      entries.forEach(([key, value]) => {
        state.form.setValue(key, value);
      });
    }),
    hide: () => localRef.current?.hide(),
  }), []);

  return (
    <Dialog
      closeOnBackdropClicked={false}
      title={"Confirm Winner Selection"}
      size="xs"
      ref={localRef}
      onHide={clickCancel}
    >
      <DialogContent className="bg-white flex flex-col">
        <>
          <Stack>
            <p>
              Are you sure you want to set <strong>{member?.fullname}</strong> as the winner? This action cannot be undone, and the customer will be officially marked as the winner of this Lucky Draw with{' '}
              {isConsolation ? (
                'the consolation prize specified below.'
              ) : (
                <>
                  the prize <strong>{prize?.name}</strong>.
                </>
              )}
            </p>
          </Stack>
          <HookFormProvider
            query={state.prizeListApi}
            form={state.form}
          >
            {isConsolation && <Stack>
              <ControlLabel className='grid-cols-1' label="Consolation Prize">
                <InputSelect
                  placeholder="Select consolation prize"
                  isMulti={false}
                  options={state.prizeList}
                  rule={{ validate: (val)=>{return Boolean(val.id)} }}
                  form={state.form}
                  name="prize"
                  selectOption={(_) => ({
                    label: _.name as string,
                    value: _.id,
                  })}
                />
              </ControlLabel>
            </Stack>}
            <Stack
              className={'border-t pt-4 border-neutral-200'}
              direction="row"
              gap={4}
            >
              <Stack
                direction="row"
                justify='end'
                gap={4}
              >
                <Button variant='outlined' onClick={()=>(localRef.current?.hide())}>Cancel</Button>
                <Button onClick={() => submitButtonClick()} loading={state.submit.isLoading} disabled={!state.form.formState.isValid}>{'Confirm'}</Button>
              </Stack>
            </Stack>
          </HookFormProvider>
        </>
      </DialogContent>
    </Dialog>
  );
};

export default TabDrawSetAsWinnerPopup;
